module.exports = __webpack_public_path__ + "img/logo-white.d125b15b.png";